import GuessTransport from "../../components/Nursery/GeneralAwareness/GuessTransport";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


document.title = "Mamas Guidance - Nursery - General Awareness - Transport Mode"; // Set page title

const topics: MenuItem[] = [
    { url: "/nursery/general-awareness/transport-mode/guess-the-transport", title: "Guess the Transport", component: GuessTransport},
];


export default topics;